export default __webpack_public_path__ + "static/media/illinois.d3f3a2af.jpg";